import { City, CommonCode } from "@prisma/client";
import { Method } from "~/enums";
import { CityDto, CodeDto, DongDto, SigunguDto } from "~/models/dto-types";
import { useLocalStorage } from "@vueuse/core";
import { useEquipStore } from "./equipStore";
import Swal from "sweetalert2";

interface allCommonCode {
	[x: string]: CommonCode[];
}


export const useCommonCodeStore = defineStore("commonCodeStore", {
	
	state: () => ({
		codeCategories: useLocalStorage("codeCategories", [] as string[]),
		allCommonCode: useLocalStorage("allCommonCode", {} as allCommonCode),
    mapCommonCode: useLocalStorage("mapCommonCode", {} as Map<string, Map<string, CodeDto>>),
		cities: useLocalStorage("cities", [] as CityDto[]),
		sigungus: useLocalStorage("sigungus", [] as SigunguDto[]),
		dongs: useLocalStorage("dongs", [] as DongDto[]),
	}),

	getters: {},
	actions: {
    init(){
      if(Object.keys(this.mapCommonCode).length === 0){
				this.getInitAllCodeMap();
			}
    },

		getEngSourceName(engSource: string) {
			let name = "pv";

			let engSourceInfo = this.getMapCode("engSource", engSource);
			switch (engSourceInfo?.codeName) {
				case "태양광": {
					name = "pv";
					break;
				}
				case "태양열": {
					name = "solarheat";
					break;
				}
				case "지열": {
					name = "geo";
					break;
				}
				case "연료전지": {
					name = "fuelcell";
					break;
				}
				case "풍력": {
					name = "wf";
					break;
				}
				case "ESS": {
					name = "ess";
					break;
				}
				default: {
					break;
				}
			}

			return name;
		},

		async getCodeCategories() {
			const res = await useFetch("/api/v1/common/code-categories", { method: Method.GET });
			// this.device = isMobile

			this.codeCategories = res.data.value as string[];
		},
		getMapCode(category: string, cd: string) {
			// console.log(this.mapCommonCode, category, cd);

      // if (!this.mapCommonCode.has(category)) {
			// 	this.init();
			// };

			// console.log(this.mapCommonCode);


      if(cd){
        return this.mapCommonCode?.get(category)?.get(cd as string) as CodeDto;
      } 
		},
    getMapCodeList(category: string) {
			if (!this.mapCommonCode.has(category)) return;
      
      return this.mapCommonCode?.get(category) as Map<string, CodeDto>;
		},
    getMapCodeToArray(category: string){
      let result = Array.from(this.getMapCodeList(category) as Map<string, CodeDto>, ([key,value]) => ({key, value}));

      return result;
    },
		getMapCodeToPlainArray(category: string){
			return this.getMapCodeToArray(category).map(v => v.value);;
		},
		async getInitAllCodeMap() {
			const res = await useFetch<CommonCode[]>("/api/v1/common/code", { method: Method.GET });
			const categoriesData = res.data.value as CommonCode[];

      this.mapCommonCode = new Map();

			for (let i = 0; i < categoriesData.length; i++) {
				if (!this.mapCommonCode.has(categoriesData[i].category)) {
          this.mapCommonCode.set(categoriesData[i].category, new Map());
				}

        this.mapCommonCode.get(categoriesData[i].category)?.set(categoriesData[i].code, categoriesData[i]);
			}

			return this.mapCommonCode;
		},

		async getCities() {
      const equipStore = useEquipStore();
      this.cities = []

			const res = await useFetch<City[]>("/api/v1/common/region/cities", { method: Method.GET });

			// for (let i = 0; i < (res.data.value as City[]).length; i++) {
      //   let cityCode = (res.data.value as City[])[i].cityCode


			// 	if (equipStore.plainEquipList.findIndex(v => v.dongCode?.substring(0,2) === cityCode) !== -1) {
			// 		this.cities.push((res.data.value as City[])[i]);
			// 	}
			// }

			this.cities = res.data.value as City[];

			// for(let i = 0; i < this.cities.length; i++){
			//   await this.getSigungu(this.cities[i].cityCode);
			// }

			return this.cities;
		},
    getCode(category: string, cd: string | undefined = undefined) {
			if (!this.allCommonCode[category]) return;

			let result = this.allCommonCode[category].find((v) => v.code.toLowerCase() === cd?.toLowerCase()) as CommonCode;
			// result['eventStatus']

			return result;
		},


		async getSigungu(cityCode: string) {
			const res = await useFetch<SigunguDto[]>(`/api/v1/common/region/cities/${cityCode}/sigungus`);

			this.sigungus = res.data.value as SigunguDto[];

			// for (let i = 0; i < sigungus.length; i++) {
			// 	if (this.sigungus.findIndex((v) => v.sigunguCode === sigungus[i].sigunguCode) === -1) {
			// 		this.sigungus.push(sigungus[i]);
			// 	}
			// }

			// for(let i = 0; i < this.sigungus.length; i++){
			//   this.getDongs(this.sigungus[i].cityCode as string, this.sigungus[i].sigunguCode);
			// }

			return this.sigungus;
		},

		async getDongs(cityCode: string, sigunguCode: string) {
			const res = await useFetch<DongDto[]>(`/api/v1/common/region/cities/${cityCode}/sigungus/${sigunguCode}/dongs`);
			this.dongs = res.data.value as DongDto[];
			return this.dongs;
		},

		async getCity(cityCode: string){
			const res = await useFetch<CityDto>(`/api/v1/common/region/cities/${cityCode}`);
			return res.data.value;
		},
		async getCitySigungu(cityCode: string, sigunguCode: string){
			const res = await useFetch<SigunguDto>(`/api/v1/common/region/cities/${cityCode}/sigungus/${sigunguCode}`);
			return res.data.value;
		},

		async getDong(cityCode: string, sigunguCode: string, dongCode: string){
			const res = await useFetch<DongDto[]>(`/api/v1/common/region/cities/${cityCode}/sigungus/${sigunguCode}/dongs/${dongCode}`);
			return res.data.value
		},

		async getCompanyInfo(category: string, syskey: string){
			const res = await useFetch(`/api/v1/common/companyaddr`, {method: Method.GET, query: {
				category: category,
				syskey: syskey
			}});

			return res.data.value;
		},
		async getCompanysList(kind: string){
			try{
				const res = await useCustomFetch(`/api/v1/common/companys`, {method: Method.GET, query:{
					kind: kind
				}});

				if(res.data.value){
					return res.data.value
				} else {
					throw new Error(res.error.value?.data.message);
				}
			}catch(e){
				Swal.fire({
      		html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        })		
			}
		},
		async getCompanyManagersList(kind: string, companySeq: string){
			try{
				const res = await useCustomFetch(`/api/v1/common/companymanagers`, {method: Method.GET, query: {
					kind: kind,
					companySeq: companySeq
				}});
				
				if(res.data.value){
					return res.data.value
				} else {
					throw new Error(res.error.value?.data.message);
				}

			}catch(e){
				Swal.fire({
      		html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        })	
			}
		}
	},
});
